import h from "trader-hyperscript";
import zipcelx, {
  ZipCelXCell,
  ZipCelXDataSet,
  ZipCelXRow,
} from "zipcelx-on-steroids";

export function downloadCsvFromTable(
  filename: string,
  id: string,
  opts?: {
    replaceNewlinesWithCommas?: boolean;
    removeDisplayNoneRows?: boolean;
  },
) {
  function download(filename: string, text: string) {
    const element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text),
    );
    element.setAttribute("download", filename + ".csv");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
  function escape(str_: string) {
    // Newlines exported into CSV don't parse well everywhere (eg: Google Sheets)
    // so I'm gonna replace them with comma's for now
    const str =
      opts?.replaceNewlinesWithCommas === true
        ? str_.replace(/\n/g, ",")
        : str_;
    if (str.includes('"') || str.includes(";")) {
      // Wrapping with quotes
      // " and \n are obvious, but Excel also seems to parse ; incorrectly if not wrapped in quotes
      // ; is used when seperating emailaddresses, which is what most email clients use themselves
      return '"' + str.replace('"', '""') + '"';
    } else {
      return str;
    }
  }
  const table = document.getElementById(id);
  if (!table) {
    throw new Error("No table found");
  }
  const trs = Array.from(table.querySelectorAll("tr"));
  const filteredTrs =
    opts?.removeDisplayNoneRows === true
      ? trs.filter((tr) => {
          return !(tr.getAttribute("style") || "").includes("display: none");
        })
      : trs;

  const str = filteredTrs
    .map(function (tr: HTMLElement) {
      const cells = tr.children;
      return Array.prototype.map
        .call(
          cells,
          function (tr: HTMLElement) {
            return escape(tr.innerText);
          },
          "",
        )
        .join(",");
    })
    .join("\n");

  download(filename, str);
}

export function downloadXlsFromTable(
  filename: string,
  id: string,
  opts?: {
    replaceNewlinesWithCommas?: boolean;
    removeDisplayNoneRows?: boolean;
  },
) {
  const table = document.getElementById(id);
  if (!table) {
    throw new Error("No table found");
  }
  const trs = Array.from(table.querySelectorAll("tr"));

  function escape(str_: string) {
    // Newlines exported into CSV don't parse well everywhere (eg: Google Sheets)
    // so I'm gonna replace them with comma's for now
    return opts?.replaceNewlinesWithCommas === true
      ? str_.replace(/\n/g, ",")
      : str_;
  }

  const filteredTrs =
    opts?.removeDisplayNoneRows === true
      ? trs.filter(
          (tr) => !(tr.getAttribute("style") || "").includes("display: none"),
        )
      : trs;

  const data: ZipCelXDataSet = filteredTrs.map(function (tr): ZipCelXRow {
    const cells = tr.children;
    return Array.from(cells).map(function (td_): ZipCelXCell {
      const td = td_ as HTMLElement;
      const i = parseFloat(td.innerText);
      const isNumber = !isNaN(i) && i.toString() == td.innerText;
      return {
        value: isNumber ? i : escape(td.innerText),
        type: isNumber ? "number" : "string",
      };
    });
  });

  const config = {
    filename: filename,
    sheet: {
      data: data,
    },
  };

  void zipcelx(config, "export");
}

export function renderTableDownloadLinks(opts: {
  tableid: string;
  filename: string;
  renderAsInlineButtons?: true;
  xlsLabel?: string;
  csvLabel?: string;
  replaceNewlinesWithCommas?: boolean;
  removeDisplayNoneRows?: boolean;
}) {
  const xlsLabel = opts.xlsLabel || "Download als xls";
  const csvLabel = opts.csvLabel || "Download als csv";
  const downloadOpts = {
    replaceNewlinesWithCommas: opts.replaceNewlinesWithCommas || false,
    removeDisplayNoneRows: opts.removeDisplayNoneRows || false,
  };
  return opts.renderAsInlineButtons === true ? (
    [
      <button
        onclick={() =>
          downloadXlsFromTable(opts.filename, opts.tableid, downloadOpts)
        }
      >
        {xlsLabel}
      </button>,
      <button
        onclick={() =>
          downloadCsvFromTable(opts.filename, opts.tableid, downloadOpts)
        }
      >
        {csvLabel}
      </button>,
    ]
  ) : (
    <section style="text-align: right;">
      <div style="font-size: 0.85em;">
        <a
          style="margin-right: 8px;"
          onclick={() =>
            downloadXlsFromTable(opts.filename, opts.tableid, downloadOpts)
          }
        >
          {xlsLabel}
        </a>
        <a
          onclick={() =>
            downloadCsvFromTable(opts.filename, opts.tableid, downloadOpts)
          }
        >
          {csvLabel}
        </a>
      </div>
    </section>
  );
}
